var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReadAloudTool = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 34,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h36v34H0V0Z",
  id: "a"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 36,
  height: 34
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 14.58v4.84a1 1 0 0 0 1 1h3.147a1 1 0 0 1 .707.294l3.701 3.7a1 1 0 0 0 1.707-.706V10.292a1 1 0 0 0-1.707-.707l-3.701 3.701a1 1 0 0 1-.707.293H9a1 1 0 0 0-1 1ZM23.393 17a5.132 5.132 0 0 0-2.85-4.595v9.179A5.101 5.101 0 0 0 23.393 17Zm-2.85-10v2.349A7.988 7.988 0 0 1 26.244 17a7.988 7.988 0 0 1-5.701 7.651V27c4.572-1.038 7.982-5.12 7.982-10s-3.41-8.962-7.982-10Z"
}))));
export default SvgReadAloudTool;